export default store => {
  return {
    async run({ strategy, type = "enter", options = {}, route, done }) {
      if (store.getters["page/status"] !== "error") {
        const map = {};

        try {
          await strategy(route, map);
        } catch (error) {
          store.dispatch("page/addError", error);
        }

        // if (options.sections && options.sections.length) {
        //   if (options.sections.every(key => !map[key] || !map[key].length)) {
        //     store.dispatch("page/setErrorCode", "serviceError");
        //   }
        // }

        if (options.required && options.required.length) {
          if (options.required.some(key => !map[key] || !map[key].length)) {
            store.dispatch("page/setErrorCode", "serviceError");
          }
        }

        const injectProps = function(data) {
          for (let key in data) {
            this[key] = data[key];
          }
        };

        if (type === "enter") {
          done(component => {
            injectProps.call(component, map);
          });
        } else {
          injectProps.call(this, map);
          done();
        }
      } else {
        done();
      }
    },
    getIdFromRoute(route) {
      try {
        return route.params.id;
      } catch (error) {
        store.dispatch("page/addError", error);
        return null;
      }
    }
  };
};
